var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.total > 0
    ? _c(
        "div",
        { staticClass: "page_wrap" },
        [
          _vm.total > 10
            ? [
                _c(
                  "el-pagination",
                  _vm._b(
                    {
                      attrs: {
                        small: _vm.small,
                        background: _vm.background,
                        "page-sizes": _vm.pageSizes,
                        "current-page": _vm.currentPage,
                        "page-size": _vm.pageSize,
                        layout: _vm.layout,
                        total: _vm.total
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:pageSize": function($event) {
                          _vm.pageSize = $event
                        },
                        "update:page-size": function($event) {
                          _vm.pageSize = $event
                        }
                      }
                    },
                    "el-pagination",
                    _vm.$attrs,
                    false
                  )
                )
              ]
            : _c("div", { staticClass: "onlyPage" }, [
                _vm._v("共 " + _vm._s(_vm.total) + " 条")
              ])
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a2f981b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a2f981b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/pagination/pagination.vue
// module id = null
// module chunks = 